import React from 'react';
import { Box } from '@theguarantors/ui-kit-v3/design-system/Box';
import { Props } from './Header.types';
import AppBar from '@mui/material/AppBar';
import TheGuarantorsLogo from '../../assets/images/TheGuarantors_Logo.svg';
import Toolbar from '@mui/material/Toolbar';

export const Header: React.FC<Props> = () => {
  return (
    <AppBar component="nav" sx={{ pr: 0, boxShadow: 'none', padding:0 }}>
      <Toolbar sx={{ backgroundColor: 'white', color: 'black', justifyContent: { sm: 'left' } }}>
        <img height="30px" alt="" src={TheGuarantorsLogo} style={{paddingLeft:'26px'}}/>
        <Box sx={{ flexGrow: 1 }} /><Box display={{ xs: 'none', sm: 'block' }}>
        </Box>
      </Toolbar>
    </AppBar>
  )
};
